import { SelectListItem } from '../lib/select/select-property';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { Router } from '@angular/router';
import * as t from '../lib/select/select-service';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { BaseeSearchClass } from 'projects/Shared-Lib/model/search-result';

const ControllerName: string = 'Role';

//search filter request api fields
export class SearchClass extends BaseeSearchClass {
    // RoleId?: string;
    RoleName?: string;
    IsEnabled?: string;
}


//structure of table for postback api
export class Role {
    //[Key] - Guid
    RoleId?: string;
    RoleName?: string;
    IsEnabled?: boolean;
    CreatedDateTime?: string;
    CreatedBy?: string;
    UpdatedBy?: string;
    UpdatedDateTime?: string;

    constructor() {
    }
}

/** Role Search class */
export class Role_Search {
    filter: SearchClass;
    ddlEnabled?: SelectListItem[];
    SelectedEnabled?: SelectListItem;
    ddlRole?: SelectListItem[];
    SelectedRole?: SelectListItem;

    CurrentUser: any;

    // private dataService: DataService;
    constructor() {
        this.filter = new SearchClass();
        this.filter.RoleName = '';
        this.filter.IsEnabled = '';

        this.ddlEnabled = t.GetItems(t.Items.Options_Enabled, true);
    }
}
/** document edit/create page models */
export class Role_Document extends Role {
    ddlEnabled?: SelectListItem[];
    SelectEnabled?: any;
    CurrentUser: any;
    
    constructor(private _dlgService: DialogService, private router: Router, private dataService: DataService) {
        super();
        this.ddlEnabled = t.GetItems(t.Items.Options_Enabled);
        //this._dlgService = new DialogService();
        this.CurrentUser = JSON.parse(localStorage.getItem('user'));
    }

    /** Get Document by UserId
     * @param uid : Guid
     */
    GetDocument(uid: string) {
        this.dataService.getData(`${ControllerName}/${uid}`, null, (ret) => {
            this.RoleId = ret.RoleId;
            this.RoleName = ret.RoleName;
            this.IsEnabled = ret.IsEnabled;
            this.SelectEnabled = ret.IsEnabled ? 1 : 0;
        });
    }
}
